import React from "react";

import "./styles.less";

export const DownRcode = ({ children, url }) => {
  return (
    <span className="down-rcode-warp">
      {children}
      <div className="down-rcode">
        <img
          src={`http://files.authing.co/authing-website/${url}`}
          alt="authing"
        />
      </div>
    </span>
  );
};
